import type { PatientCardSource } from '@/components/patient-card/patient-card-data';
import { useQueryEncounterById } from '@/features/patient-360/services/use-query-encounter-by-id';
import { useQueryLabReportById } from '@/features/patient-360/services/use-query-lab-report-by-id';
import { useQueryPatientCard } from '@/features/patient-360/services/use-query-patient-card';
import { useReportContent } from '@/features/patient-360/services/use-report-content';

export const CdrPatientCardSource: PatientCardSource = ({
  mrn,
  encounterId,
  reportId,
  reportType,
  children,
}) => {
  const patient = useQueryPatientCard(mrn, { enabled: true });
  const encounter = useQueryEncounterById(encounterId, { enabled: true });
  const labReportId = reportType ? undefined : reportId;
  const labReport = useQueryLabReportById(labReportId);
  const reportContent = useReportContent({ type: reportType, id: reportId });

  return children({
    patient,
    encounter,
    details: {
      labReport: { requested: Boolean(labReportId), query: labReport },
      reportContent: {
        requested: Boolean(reportType && reportId),
        ...reportContent,
      },
    },
  });
};
